import React from "react";

class Table extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            style: {

            },
            result: this.props.end,
            begin: this.props.start,
            ident: "result-table"
        }
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.end !== this.state.result) {
            this.setState({result: nextProps.end});
        }
        if (nextProps.start !== this.state.begin) {
            this.setState({begin: nextProps.start});
        }
    }

    render() {
        return (
            <div className={this.state.ident}>
                <p className="attn" style={{textDecoration:"underline", fontStyle:"italic", clear:"both"}}>Implications of proposed scale-up</p>
                <p style={{textAlign:"center"}}>{this.props.expo}</p>
                <section>
                    <p>Baseline #</p>
                    <p>Endline #</p>
                </section>
                <section>
                    <p>{this.state.begin}</p>
                    <p>{this.state.result}</p>
                </section>


            </div>
        )
    }
}

export default Table;


// WEBPACK FOOTER //
// ./src/table.js